var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRcgeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_rcgerc_56px",
    transform: "translate(-110 -3340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img_rcg_50px",
    transform: "translate(-346 2522)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_52",
    "data-name": "\\uD0C0\\uC6D0 52",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(456 818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_220",
    "data-name": "\\uADF8\\uB8F9 220",
    transform: "translate(466 828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_466",
    "data-name": "\\uD328\\uC2A4 466",
    d: "M-185.37,572.093a1.213,1.213,0,0,0-1.713.048,1.213,1.213,0,0,0,.048,1.713,12.2,12.2,0,0,1,3.857,8.948,12.324,12.324,0,0,1-12.31,12.31A12.323,12.323,0,0,1-207.8,582.8a12.2,12.2,0,0,1,3.856-8.948,1.211,1.211,0,0,0,.048-1.713,1.213,1.213,0,0,0-1.713-.048,14.6,14.6,0,0,0-4.616,10.71,14.751,14.751,0,0,0,14.734,14.734A14.751,14.751,0,0,0-180.754,582.8,14.6,14.6,0,0,0-185.37,572.093Z",
    transform: "translate(210.222 -567.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_467",
    "data-name": "\\uD328\\uC2A4 467",
    d: "M-191.558,580.538a1.212,1.212,0,0,0,1.212-1.212V568.87a1.212,1.212,0,0,0-1.212-1.212,1.212,1.212,0,0,0-1.212,1.212v10.456A1.212,1.212,0,0,0-191.558,580.538Z",
    transform: "translate(210.74 -567.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_468",
    "data-name": "\\uD328\\uC2A4 468",
    d: "M-200.177,580.538a1.212,1.212,0,0,0,1.212-1.212V568.87a1.212,1.212,0,0,0-1.212-1.212,1.212,1.212,0,0,0-1.212,1.212v10.456A1.212,1.212,0,0,0-200.177,580.538Z",
    transform: "translate(210.484 -567.658)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "img_eth_25px",
    transform: "translate(-320 2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_54",
    "data-name": "\\uD0C0\\uC6D0 54",
    transform: "translate(456 1349)",
    fill: "#fff",
    stroke: "#1c1e35",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img_erc20",
    transform: "translate(463.316 1351.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_211",
    "data-name": "\\uD328\\uC2A4 211",
    d: "M464.038,314.78v6.259l7.684-10.792Z",
    transform: "translate(-456.355 -296.04)",
    fill: "#232423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_212",
    "data-name": "\\uD328\\uC2A4 212",
    d: "M464.038,219.982v8.034l7.684-4.545Z",
    transform: "translate(-456.355 -210.724)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_213",
    "data-name": "\\uD328\\uC2A4 213",
    d: "M464.038,51.13v9.258l7.684,3.489Z",
    transform: "translate(-456.355 -51.13)",
    fill: "#232423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_214",
    "data-name": "\\uD328\\uC2A4 214",
    d: "M331.592,314.78v6.259l-7.684-10.792Z",
    transform: "translate(-323.908 -296.04)",
    fill: "#6f7071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_215",
    "data-name": "\\uD328\\uC2A4 215",
    d: "M331.595,219.982v8.034l-7.683-4.545Z",
    transform: "translate(-323.911 -210.724)",
    fill: "#272828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_216",
    "data-name": "\\uD328\\uC2A4 216",
    d: "M331.595,51.13v9.258l-7.683,3.489Z",
    transform: "translate(-323.911 -51.13)",
    fill: "#6f7071"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcgeth);
export default __webpack_public_path__ + "static/media/RCGETH.ec499fcb.svg";
export { ForwardRef as ReactComponent };